/**
 * Microsoft OneDrive 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <MicrosoftOneDriveIcon className="w-8 h-8" />
 * <MicrosoftOneDriveIcon className="w-12 h-12" />
 * ```
 */
export function MicrosoftOneDriveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Microsoft OneDrive icon"
      role="img"
    >
      <title>Microsoft OneDrive</title>
      <g id="Microsoft Poweronedrive">
        <g id="Vector">
          <path
            d="M12.6771 11.9987L18.5554 15.5308L22.0579 14.0517C22.7697 13.7429 23.5371 13.5846 24.3125 13.5854C24.4417 13.5854 24.5694 13.5912 24.6964 13.5998C24.2753 11.952 23.3864 10.4625 22.1376 9.31219C20.8888 8.16188 19.3339 7.40031 17.6619 7.12003C15.99 6.83974 14.2728 7.05281 12.7193 7.73335C11.1657 8.41388 9.84251 9.53257 8.91056 10.9535C8.9405 10.9531 8.96999 10.9512 9 10.9512C10.2991 10.9495 11.5727 11.3123 12.6771 11.9987Z"
            fill="#0364B8"
          />
          <path
            d="M12.6771 11.9987C11.5727 11.3123 10.2991 10.9495 9 10.9512C8.96999 10.9512 8.9405 10.9531 8.91056 10.9535C7.6391 10.9693 6.39595 11.3325 5.31473 12.004C4.2335 12.6755 3.35507 13.63 2.77382 14.7649C2.19258 15.8997 1.9305 17.1721 2.01574 18.4452C2.10099 19.7183 2.53034 20.9441 3.25765 21.9907L18.5554 15.5308L12.6771 11.9987Z"
            fill="#0078D4"
          />
          <path
            d="M24.6964 13.5998C24.5694 13.5912 24.4417 13.5854 24.3125 13.5854C23.5371 13.5846 22.7697 13.7429 22.0579 14.0517L18.5554 15.5308L29.3197 22.001C29.771 21.1603 30.0049 20.2193 29.9999 19.2644C29.995 18.3095 29.7513 17.3711 29.2913 16.5351C28.8312 15.6992 28.1695 14.9924 27.3668 14.4796C26.564 13.9668 25.6459 13.6642 24.6964 13.5998Z"
            fill="#1490DF"
          />
          <path
            d="M18.5554 15.5308L3.25765 21.9907C3.9018 22.9201 4.76052 23.6792 5.76047 24.2032C6.76042 24.7272 7.8719 25.0006 9 25H24.3125C25.3392 25.0003 26.3468 24.7217 27.2284 24.1936C28.11 23.6656 28.8327 22.9079 29.3197 22.001L18.5554 15.5308Z"
            fill="#28A8EA"
          />
        </g>
      </g>
    </svg>
  );
}
